// 移动端社会招聘
import React from 'react'
import styles from './index.module.scss'
import defaultSetting from '@/setting'
import {getPositionsNumlApi} from '@/api'
import {getUrlParams} from "@/utils/util"

const banner = require('@/assets/mobileImages/social/banner.png')
const list_01 = require("@/assets/mobileImages/social/list_01.png")
const list_02 = require("@/assets/mobileImages/social/list_02.png")
const list_03 = require("@/assets/mobileImages/social/list_03.png")

class MobileSocial extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
                {
                    id: 1,
                    imgUrl: list_01,
                    toUrl: `/${defaultSetting.suiteKeyMc}/mc/position/society?projectCode=202001&orgCode=${getUrlParams().orgCode}`,
                    title: "高端领军人才",
                    content: ' 个在招职位'
                },
                {
                    id: 2,
                    imgUrl: list_02,
                    toUrl: `/${defaultSetting.suiteKeyMc}/mc/position/society?projectCode=202501&orgCode=${getUrlParams().orgCode}`,
                    title: "社会成熟人才",
                    content: ' 个在招职位'
                },
                {
                    id: 3,
                    imgUrl: list_03,
                    toUrl: `https://www.hotjob.cn/wt/FAW/irmob/web/login`,
                    title: "员工内部推荐",
                    content: ' 个在招职位'
                },
            ],
            positionsCode: ['202001', '201701'],
            positionsNum: [],
        }
    }

    componentWillMount() {
        if (defaultSetting.grayscale) {
            document.querySelector('html').classList.add('grayscale');
        }
    }

    componentDidMount() {
        const {orgCode} = getUrlParams();

        getPositionsNumlApi({recruitType: 2, curSearchEle: 'project', orgCode}).then(res => {
            let {positionsCode, positionsNum} = this.state;
            const {projectList} = res.data;

            for (let i = 0; i < positionsCode.length; i++) {
                for (let j = 0; j < projectList.length; j++) {
                    if (positionsCode[i] === projectList[j].code) {
                        positionsNum[i] = projectList[j].positionsNum;
                    }
                }
            }

            this.setState({
                positionsNum
            })
        })

        document.querySelector('.footer').style.display = 'none';
    }

    render() {
        const {list, positionsNum} = this.state;
        return (
            <>
                <main className={styles.mobileSocial}>
                    <div className="bannerCon">
                        <img src={banner} alt="banner"/>
                    </div>
                    <div className="listCon">
                        {
                            list.map((item, index) => (
                                <a className="lists" key={index} href={item.toUrl ? item.toUrl : 'javascript:void(0);'}>
                                    <img src={item.imgUrl} alt="pic"/>
                                    <div className="content">
                                        <p>{item.title}</p>
                                        <p style={{visibility: item.id === 3 ? 'hidden' : ''}}>{positionsNum[index] || 0}{item.content}</p>
                                    </div>
                                </a>
                            ))
                        }
                    </div>
                </main>
            </>
        );
    }
}

export default MobileSocial;